import { TKIconError } from "assets/images/svgs";
import React from "react";

const EmptyProjects = () => {
  return (
    <div className="flex flex-col max-sm:w-[350px] items-center justify-center gap-6">
      <TKIconError className="max-md:w-48 max-md:h-48" />
      <p className="text-[#7A7A7A] text-center text-[24px] max-md:text-[12px]">
        No available project at the moment. <br /> Kindly check back later.
      </p>
    </div>
  );
};

export default EmptyProjects;
